<template>
    <div>
        <table-page
            :client="client"
            @updated="getEarnings"
            :warnings="warnings"
            :changelogs="changelogs"
            :hideTabs="true"
        >
            <fast-table
                :recordLabel="recordLabel"
                :sections="sections"
                :headers="headers"
                :data="tableData"
                :activeRowId="currentEarningId"
                @click="currentEarningId = $event.id"
            >
                <template v-slot:table-actions>
                    <button class="btn btn-primary btn-collapse" id="addEarningButton" @click="openAddEarningModal">
                        <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Earning</span>
                    </button>
                </template>
            </fast-table>

            <add-earning-modal v-if="addEarningModalOpen" :client="client" ref="addEarningModal" @updated="getEarnings" @close="addEarningModalOpen = false"/>
        </table-page>

        <earning-sidebar
            v-if="currentEarning"
            :client="client"
            :earning-id="currentEarning.id"
            ref="earningSidebar"
            @updated="getEarnings"
            @close="currentEarningId = null"
        >
        </earning-sidebar>
    </div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import EarningSidebar from './components/Earnings/EarningSidebar'
import AddEarningModal from './components/Earnings/AddEarningModal'

export default {
    components: {FastTable, EarningSidebar, AddEarningModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentEarning() {
            return this.earnings.find(e => (e.id == this.currentEarningId))
        },
        sections() {
            let sections = [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: true},
            ]
            return sections
        },
        activeEarnings() {
            return this.earnings.filter((p) => {return p.is_active})
        },
        inactiveEarnings() {
            return this.earnings.filter((p) => {return !p.is_active})
        },
        tableData() {
            const tableData = []
            const subsets = [
                this.activeEarnings,
                this.inactiveEarnings,
            ]

            subsets.forEach(earnings => {
                const sectionData = []

                earnings.forEach(earning => {
                    sectionData.push({
                        id: earning.id,
                        object: earning,
                        cells: this.makeEarningTableData(earning),
                    })
                })
                tableData.push(sectionData)
            })
            return tableData
        },
    },
    data() {
        return {
            earnings: [],
            dataLoaded: false,
            currentEarningId: null,
            recordLabel: "Earnings",
            headers: [
                {label: 'Company', classes: 'cell-company', isFilterable: true, isSearchable: false, defaultSort: true},
                {label: 'Earning Name', classes: '', isSearchable: true},
                {label: 'Type', classes: 'cw-4', isSearchable: false, isFilterable: true},
                {label: 'Positions', classes: 'cw-4', isSearchable: false},
                // {label: 'Status', classes: '', isSearchable: false, isFilterable: true},
            ],
            addEarningModalOpen: false
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Earnings')
        this.getEarnings()
    },
    methods: {
        getEarnings() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/earning-types`).then(resp => {
                this.earnings = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
        makeEarningTableData(earning) {
            return [
                earning.company.name,
                earning.earning_type.name,
                earning.earning_type.current_version.type_pretty,
                earning.num_positions,
                // earning.is_active ? 'Active' : 'Inactive'
            ]
        },
        openAddEarningModal() {
            this.addEarningModalOpen = true
        }
    },
}
</script>
